<template>
    <base-dialog :value="dialog" :width="500" :title="`${$t('common.questionnaire')}s`"
        @input="val => { if (!val) hide() }" @close="hide">
        <div class="qs-list">
            <div class="qs-item" v-for="(item, i) in summary" :key="i">
                <div class="qs-row">
                    <span class="qs-ref">{{ item.reference }}</span>
                    <span class="qs-val">
                        <template v-if="isGroupedBodyValue(item.value)">
                            <span v-for="(group, gi) in item.value" :key="gi" class="qs-body-group">
                                <span class="qs-body-title">{{ group.section }}</span>
                                <span class="qs-body-values">
                                    <span v-for="(entry, ei) in parseBodyValues(group.values)" :key="ei"
                                        class="qs-body-zone">
                                        <span v-if="entry.level" class="qs-body-lv" :style="bodyBadgeStyle(entry.level)">
                                            {{ entry.level }}
                                        </span>
                                        {{ entry.text }}
                                    </span>
                                </span>
                            </span>
                        </template>
                        <template v-else-if="Array.isArray(item.value)">{{ item.value.join(', ') }}</template>
                        <template v-else>{{ item.value }}</template>
                    </span>
                </div>
                <div v-if="item.comment" class="qs-comment">{{ $t('common.comment') }}: {{ item.comment }}</div>
            </div>
        </div>
    </base-dialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";

const PAIN_COLORS = ['', '#FDE68A', '#FBBF24', '#FB923C', '#F1553B', '#8B1A1A']

export default {
    components: { BaseDialog },
    props: {
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
        isThirdDialog: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dialog: false,
            summary: null,
        }
    },
    computed: {
    },
    methods: {
        show(summary) {
            const vm = this
            vm.dialog = true
            vm.summary = summary
        },
        hide() {
            const vm = this;
            vm.dialog = false
            vm.summary = null
        },
        isGroupedBodyValue(val) {
            return Array.isArray(val)
                && val.length > 0
                && val.every(v => v && typeof v === 'object' && 'section' in v && Array.isArray(v.values))
        },
        parseBodyValues(values) {
            return (values || []).map(v => {
                const match = /^(.*) \((\d)\)$/.exec(v)
                if (match) return { text: match[1], level: Number(match[2]) }
                return { text: v, level: 0 }
            })
        },
        bodyBadgeStyle(level) {
            return {
                background: PAIN_COLORS[level],
                color: level >= 4 ? '#fff' : '#4a2f12',
            }
        },
    },
}
</script>

<style scoped>
.qs-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.qs-item {
    border: 1px solid var(--v-outline-base);
    border-radius: 10px;
    background: var(--v-surface2-base);
    overflow: hidden;
}

.qs-row {
    display: flex;
    align-items: stretch;
}

.qs-ref {
    flex: 0 0 45%;
    padding: 12px 14px;
    font-size: 13px;
    font-weight: 600;
    color: var(--v-txtSecondary-base);
    background: var(--v-field-base);
    display: flex;
    align-items: center;
    border-right: 1px solid var(--v-outline-base);
}

.qs-val {
    flex: 1;
    min-width: 0;
    padding: 12px 14px;
    font-size: 13px;
    font-weight: 600;
    color: var(--v-txtPrimary-base);
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
}

.qs-body-group {
    display: flex;
    flex-direction: column;
}

.qs-body-title {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .04em;
    color: var(--v-txtMuted-base);
}

.qs-body-values {
    font-size: 13px;
    display: flex;
    flex-wrap: wrap;
    gap: 4px 10px;
}

.qs-body-zone {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.qs-body-lv {
    border-radius: 4px;
    padding: 0 5px;
    font-size: 11px;
    font-weight: 800;
    line-height: 1.4;
}

.qs-comment {
    padding: 10px 14px;
    font-size: 12px;
    line-height: 1.5;
    color: var(--v-txtSecondary-base);
    border-top: 1px solid var(--v-outline-base);
}
</style>
